// extracted by mini-css-extract-plugin
export default {"btnWrap":"VoiceCallButton_btnWrap__rg30k","disabled":"VoiceCallButton_disabled__62FCC","title":"VoiceCallButton_title__-PE4X","icon":"VoiceCallButton_icon__JRnQH"};